var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprofileHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0017 6.03864C19.1337 3.22664 23.9737 3.31997 26.991 6.34264C30.007 9.36664 30.111 14.1826 27.3057 17.324L15.999 28.6466L4.695 17.324C1.88967 14.1826 1.995 9.35864 5.00967 6.34264C8.02967 3.32397 12.8603 3.22264 16.0017 6.03864ZM25.103 8.22664C23.103 6.22397 19.8763 6.14264 17.783 8.02264L16.003 9.61997L14.2217 8.02397C12.1217 6.14131 8.90167 6.22397 6.89633 8.22931C4.90967 10.216 4.80967 13.396 6.64033 15.4973L16.0003 24.872L25.3603 15.4986C27.1923 13.396 27.0923 10.22 25.103 8.22664Z",
    fill: "url(#paint0_linear_2993_1522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2993_1522",
    x1: 2.66699,
    y1: 28.6466,
    x2: 27.2373,
    y2: 2.06204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprofileHeart);
export default __webpack_public_path__ + "static/media/SprofileHeart.7034795f378693aa8044ce1dbd760684.svg";
export { ForwardRef as ReactComponent };